import { render, staticRenderFns } from "./OmdContactUs.vue?vue&type=template&id=0d328c00&scoped=true"
var script = {}
import style0 from "./OmdContactUs.vue?vue&type=style&index=0&id=0d328c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d328c00",
  null
  
)

export default component.exports